<div id="sign-in-form-container" class="cyber-form">
  <!-- Header -->
    <div class="signup-header">
      <div class="signup-logo">
        <i class="fas fa-shield-alt"></i>
      </div>
      <h1>Get Started with Scan Ninja</h1>
      <p class="signup-subtitle">
        Create your account, verify your email, then choose the plan that fits
        your team.
      </p>
    </div>

  <form
    id="register"
    [formGroup]="form"
    (ngSubmit)="onSubmit()"
    aria-describedby="server-error"
  >
    <label for="su-email" class="visually-hidden">Email</label>
    <input title="Form input"
      id="su-email"
      class="form-control"
      [class.is-invalid]="isFieldInvalid('email')"
      formControlName="email"
      type="email"
      placeholder="Email"
      autocomplete="email"
      required
    />

    @if (isFieldInvalid('email')) {
      <div class="text-danger small" role="status">
        @if (email?.hasError('required')) {
          You must enter an email address
        } @else {
          You must enter a valid email address
        }
      </div>
    }

    <label for="su-password" class="visually-hidden">Password</label>
    <div class="form-group" [ngClass]="{ accent: email && email.valid }">
      <input title="Form input"
        id="su-password"
        class="form-control"
        [class.is-invalid]="isFieldInvalid('password')"
        formControlName="password"
        type="password"
        placeholder="Password"
        autocomplete="new-password"
        required
      />
    </div>

    <label for="su-password-confirm" class="visually-hidden"
      >Confirm password</label
    >
    <div class="form-group">
      <input title="Form input"
        id="su-password-confirm"
        class="form-control"
        [class.is-invalid]="
          isFieldInvalid('passwordConfirm') || showPasswordMismatch
        "
        formControlName="passwordConfirm"
        type="password"
        placeholder="Confirm password"
        autocomplete="new-password"
        required
      />
      @if (isFieldInvalid('passwordConfirm')) {
        <div class="text-danger small" role="status">
          Please confirm your password
        </div>
      } @else if (showPasswordMismatch) {
        <div class="text-danger small" role="status">
          Password does not match
        </div>
      }
      @if (isFieldInvalid('password')) {
        <div class="password-rules mt-2">
          <div
            [ngClass]="{
              'text-success': minLengthValid,
              'text-danger': !minLengthValid,
            }"
          >
            <i
              [attr.class]="
                minLengthValid ? 'bi-check-square-fill' : 'bi-x-square'
              "
            ></i>
            Must be at least 15 characters long. A few words strung together
            work well; no special characters needed.
          </div>
        </div>
      }
    </div>

    <div id="server-error">
      @if (showMergePrompt) {
        <div class="merge-prompt" role="alert" aria-live="assertive">
          <div class="merge-prompt-header">
            <i class="bi bi-envelope-exclamation-fill merge-icon" aria-hidden="true"></i>
            <strong>Email Already Registered</strong>
          </div>
          <p class="merge-prompt-body">
            <strong>{{ email?.value }}</strong> is already linked to an account.
            @if (existingProviders.includes('google.com') || existingProviders.includes('microsoft.com')) {
              Sign in with your existing provider below to connect your password credentials, or sign in from the login page.
            } @else {
              Sign in to your existing account instead.
            }
          </p>
          <div class="merge-actions">
            @if (existingProviders.includes('google.com')) {
              <button
                type="button"
                class="btn btn-merge-provider"
                (click)="mergeWithProvider('google.com')"
                [disabled]="loading"
                aria-label="Sign in with Google and link your password"
              >
                <i class="bi bi-google me-2" aria-hidden="true"></i>Continue with Google &amp; Link Password
              </button>
            }
            @if (existingProviders.includes('microsoft.com')) {
              <button
                type="button"
                class="btn btn-merge-provider"
                (click)="mergeWithProvider('microsoft.com')"
                [disabled]="loading"
                aria-label="Sign in with Microsoft and link your password"
              >
                <i class="bi bi-microsoft me-2" aria-hidden="true"></i>Continue with Microsoft &amp; Link Password
              </button>
            }
            <button
              type="button"
              class="btn btn-login-instead"
              (click)="navigateToLogin()"
              [disabled]="loading"
            >
              <i class="bi bi-box-arrow-in-right me-2" aria-hidden="true"></i>Sign In Instead
            </button>
            <button
              type="button"
              class="btn-link-dismiss"
              (click)="dismissMergePrompt()"
              [disabled]="loading"
            >
              Try a different email
            </button>
          </div>
        </div>
      } @else if (serverMessage) {
        <div class="server-error" role="alert" aria-live="polite">{{ serverMessage }}</div>
      }
    </div>

    <div class="form-group">
      <button
        class="btn btn-primary"
        type="submit"
        [disabled]="form.invalid || !passwordDoesMatch || loading || showMergePrompt"
      >
        Sign Up
      </button>
    </div>

    <div class="form-actions">
      <a
        class="btn btn-secondary"
        [routerLink]="['/login']"
        routerLinkActive="active"
        >Back to Login</a
      >
      <a class="btn btn-ghost" [routerLink]="['/login']">Have an account?</a>
    </div>
  </form>

  <app-provider-logins></app-provider-logins>
</div>
